let directoryDemoQueryMixins = {
    computed: {
        suggestions() {
            return this.$store.state.currentSuggestions || {};
        },
        term: {
            get() {
                return this.$store.state.term;
            },
            set(newVal) {
                this.$store.commit('term', newVal);
            }
        }
    },
    data() {
        return {
            showSuggestions: false
        }
    },
    watch: {
        term(newVal, oldVal) {
            if (newVal === undefined || newVal === oldVal || newVal.length < 2) {
                return;
            }

            this.$store.dispatch('suggestionsForTerm', this.term);
        }
    },
    methods: {
        /**
         * @param {string} suggestedQuery
         * @returns {string}
         */
        suggestedQueryHighlighted(suggestedQuery) {
            if (!suggestedQuery) {
                return '';
            }

            let pattern = new RegExp('(' + this.term + ')');

            return suggestedQuery.replace(pattern, '<strong>$1</strong>');
        },
        /**
         * @param {Event} e
         */
        searchFromKeyPress(e) {
            if (e.keyCode !== 13) { // only on 'Enter'
                return;
            }

            this.showSuggestions = false;
            this.search(e);
        }
    }
}

export default directoryDemoQueryMixins;